var controllers =  {

}
self.controllers = controllers
export default controllers
